import { decodeJwt } from "@/utils/decode-jwt.js";

const state = {
  isThermal: false,
  isBobbieContext: false,
};

const actions = {};

const mutations = {
  setIsThermal(state, value) {
    state.setIsThermal = value;
  },
  setIsBobbieContext(state, value) {
    state.isBobbieContext = value;
  },
};

export default {
  state,
  actions,
  mutations,
};
